export default __webpack_public_path__ + "static/media/wb.f9dab912.png";